import React from 'react';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaTimes } from 'react-icons/fa';
import DateTimePicker from 'react-datetime-picker';

import Filter from '../../filter/FilterPannel';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import FieldController from '../../../controller/FieldController';

class ConditionDate extends React.Component {

  onConditionChanged = condition => {
    let filter = { ...this.props.filter };
    filter = { ...filter, condition, value: condition ? condition.value ? condition.value : 'today' : 'today',  andor: false };
    this.props.onFilterChanged(this.props.index, filter);
  }

  onDateChanged = (source, date) => {
    let filter = { ...this.props.filter };
    let value = '';
    
    const from = filter.from;
    const to = filter.to;
    if(source === 'from' && date !== null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if(source === 'from' && date !== null && to === null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}`;
    } else if(source === 'from' && date === null && to !== null) {
      value = `${Util.dateToServerDateTime(date)}${Const.Opt}${Util.dateToServerDateTime(to)}`;
    } else if(source === 'to' && from !== null && date !== null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}${Util.dateToServerDateTime(date)}`;
    } else if(source === 'to' && from !== null && date === null) {
      value = `${Util.dateToServerDateTime(from)}${Const.Opt}`;
    } else if(source === 'to' && from === null && date !== null) {
      value = `${Const.Opt}${Util.dateToServerDateTime(date)}`;
    }

    if(source === 'from') {
      filter = { ...filter, value, from: date };
    } else { 
      filter = { ...filter, value, to: date };
    }
    this.props.onFilterChanged(this.props.index, filter);
  }

  onRangeChanged = (source, range) => {
    let filter = { ...this.props.filter };
    const selection = filter.value && filter.value.includes(Const.Opt) ? filter.value.split(Const.Opt)[0] : '';
    const increment = filter.value && filter.value.includes(Const.Opt) ? filter.value.split(Const.Opt)[1] : 0;
    let value = '';
    if(source === 'selection') {
      value = `${range.value}${Const.Opt}${increment}`;
    } else {
      value = `${selection}${Const.Opt}${range}`;
    }
    filter = { ...filter, value};
    this.props.onFilterChanged(this.props.index, filter);
  }

  render() {
    const i = this.props.index;
    const filter = this.props.filter;
    const options = FieldController.getDateRangeConditions();
    const SelectionIncrement = filter.value && filter.value.includes(Const.Opt) ? filter.value.split(Const.Opt) : ['', 0];
    return (
      <div key={`condition_${i}`} className="col-md-12 condition-select-div">
        {filter.field.label}
        
        <div className="condition-select col-md-3">
          <Select value={filter.condition} 
            onChange={ selected => this.onConditionChanged(selected) }
            options={filter.conditions} isSearchable={true} isClearable={true} />
        </div>

        <div className="condition-select col-md-8 value-float">
          { filter.condition && (filter.condition.value === Filter.In || filter.condition.value === Filter.NotIn)
            ? 
              <>
                <DateTimePicker value={filter.from && typeof filter.from === 'object' ? filter.from : null}
                  format="dd-MM-y" onChange={ date => this.onDateChanged('from', date)} />
                <DateTimePicker value={filter.to && typeof filter.to === 'object' ? filter.to : null}
                  format="dd-MM-y" onChange={ date => this.onDateChanged('to', date)} />
              </>
            : null
          }


          { filter.condition && (filter.condition.value === Filter.StartWith || filter.condition.value === Filter.EndsWith)
            ?
              <>
                <Select value={options.find(item => item.value === `${SelectionIncrement[0]}`)} 
                  onChange={selected => this.onRangeChanged('selection', selected) }
                  options={options} isSearchable={true} isClearable={true} />
                <FormControl type="number" value={SelectionIncrement[1]}
                  onChange={ event => this.onRangeChanged('increment', event.target.value) } />
              </>
            : null
          }

          { false && (filter.isSelect || filter.isCity || filter.isState || filter.isCountry)
            && filter.select && filter.select.length > 1
            ? <div>
                <label>Inner Condition</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={filter.andor}
                    onChange={() => this.onCondition(i, true)} />
                  <Form.Check.Label>AND</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={!filter.andor}
                    onChange={() => this.onCondition(i, false)} />
                  <Form.Check.Label>OR</Form.Check.Label>
                </Form.Check>
              </div>
            : null
          }

          <Button variant="danger" onClick={() => this.props.onDelete(i)}><FaTimes /></Button>
        </div>
      </div>
    );
  }
}
export default ConditionDate;